import React from 'react';
import styled, { css } from 'styled-components';

import { Button, BUTTON_TYPES, Text, Flex, Spacer } from '@badi/badi-components';
import { translate } from 'base/shared/Localization';
import BookingCheckoutButton from 'modules/stripe/booking-checkout';
import FloatingChatBubble from 'components/FloatingChatBubble';
import BookingFooter from '../footer';

const LegalText = styled.div`
  a {
    text-decoration: underline;
  }
`;

const PaymentCheckoutFooter = ({
  bookingRequestId,
  onMessageClick,
  isBadiPlusRoom,
  stepIsValid,
  disabled,
  guestParams,
  room,
  moveIn,
  moveOut,
  depositAmount = null,
}) => {
  const handleOpenModal = () => {
    openBookingBenefitsModal();
  };

  console.log(depositAmount, 'depositAmount');
  return (
    <BookingFooter>
      <FloatingChatBubble room={room} moveIn={moveIn} moveOut={moveOut} guestParams={guestParams} />
      <LegalText>
        <Text
          body={6}
          data-qa="badi-plus-confirmation-tc"
          inline={false}
          align="center"
          dangerouslySetInnerHTML={{
            __html: translate('recovery.badi_plus_confirmation_tc', {
              policy_link: translate('sitemap.privacy.link'),
              terms_link: translate('sitemap.badiplus.tc.link'),
            }),
          }}
        />
      </LegalText>

      <BookingCheckoutButton
        bookingRequestId={bookingRequestId}
        callback={() => {}}
        disabled={!stepIsValid || disabled}
        dataQa="submit-booking-checkout-button"
        guestParams={guestParams}
        fullWidth={true}
        grow={1}
        variant="primary"
      >
        {depositAmount
          ? translate('recovery.badi_plus_book_now_cta_with_deposit_amount', {
              amount: depositAmount,
            })
          : translate('room.detail.cta_book_now')}
      </BookingCheckoutButton>
    </BookingFooter>
  );
};

export default PaymentCheckoutFooter;
